<template>
  <div id="app">
    <main-page ref="MainPage"></main-page>
  </div>
</template>

<script>
import MainPage from '@/pages/MainPage'
export default {
  name: 'App',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    MainPage
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: rgba(0,100,191,1);
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.custom-message{
  width:80% !important;
  min-width: 0 !important;
  height: 50px;
  border-radius: 2px;
  /* background: red; */
  background-color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/App.vue